import { createElement } from 'react';

const SvgCheck = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 10 8", fill: "none" }, props),
    createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.563 1.06c.081.08.083.213.004.295l-5.34 5.582a.203.203 0 01-.295-.002l-2.875-3.07a.212.212 0 01.007-.295.203.203 0 01.29.006L4.082 6.49l5.19-5.426a.203.203 0 01.291-.004z", fill: "#28B583", stroke: "#28B583", strokeWidth: 0.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));

export default SvgCheck;
